import React from 'react';
import { Button as StyledButton } from './styles';

export interface ButtonProps {
  label: string;
  type: "standard" | "outlined" | "contained" | "text";
  isDisabled?: boolean
  onClick?: () => void;
}

export const Button = ({ 
  label,
  type,
  isDisabled,
  onClick,
  ...rest
} : ButtonProps) => {
  return (
    <StyledButton 
      {...rest} 
      className={`${type} ${isDisabled && 'disabled'}`} 
      onClick={onClick}
      disabled={isDisabled}
    >
      {label}
    </StyledButton>
  );
};

export default Button;
